import React, { useEffect, useState } from "react";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { Modal, Table, Row, Col, TreeSelect, Badge, Drawer } from "antd";
import { errorHandle, openNotificationWithIcon } from "../../../Function";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { ListBoPhanApi } from "../../../../api/getListTeam";
import {
  autoAttendApi,
  DeleteAutoAttendApi,
  PostAutoAttendApi,
} from "api/getAutoAttend";
import ModalAddTeamAuto from "./ModalAddTeamAuto";

const ModalAutoAttend = (params) => {
  const defaultPageSize = 50;
  const [pager, setPager] = useState({
    pageSize: defaultPageSize,
    count: 0,
    current: 1,
  });
  const [data, setData] = useState([]);
  const [lsTeam, setLsTeam] = useState([]);
  const [loading, setLoading] = useState(false);
  const [treeData, setTreeData] = useState([]);
  const [currentTeam, setCurrentTeam] = useState([]);
  const userInfo = useSelector((state) => state.getUserInfo.userInfo);
  const [lsBoPhan, setLsBoPhan] = useState([]);
  const [currentBoPhan, setCurrentBoPhan] = useState([]);
  const [treeDataBoPhan, setTreeDataBoPhan] = useState([]);
  const [lsAllTeam, setLsAllTeam] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isModalAddTeamAuto, setModalAddTeamAuto] = useState(false);

  const showDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);

  const onSetAuto = (record) => {
    setLoading(true);
    if (record.is_auto_attend == false) {
      PostAutoAttendApi({
        ls_id_user: [record.id],
      })
        .then((r) => {
          fetchData({ idTeam: currentTeam });
          setLoading(false);
        })
        .catch((err) => {
          if (err.data.error) {
            openNotificationWithIcon("error", err.data.error);
            setLoading(false);
          }
        });
    } else {
      DeleteAutoAttendApi({ ls_id_auto: [record.id_auto_attend] })
        .then((r) => {
          fetchData({ idTeam: currentTeam });
          setLoading(false);
        })
        .catch((err) => {
          if (err.data.error) {
            openNotificationWithIcon("error", err.data.error);
            setLoading(false);
          }
        });
    }
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      align: "center",
      width: 100,
      render: (value, item, index) =>
        ((pager.current || 1) - 1) * pager.pageSize + index + 1,
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Nhân viên",
      dataIndex: "username",
      key: "username",
      filterKey: "username",
      type: "text",
      align: "center",
      canSearch: true,
      render: (text, record) => `${record.msnv}-${record.username}`,
    },
    {
      title: "Chấm công ca sáng T7",
      dataIndex: "is_auto_attend",
      key: "is_auto_attend",
      filterKey: "is_auto_attend",
      type: "text",
      align: "center",
      canSearch: true,
      render: (value, record) =>
        value === true ? (
          <CheckCircleOutlined
            style={{ color: "#008000" }}
            title="Có chấm công tự động"
            onClick={() => onSetAuto(record)}
          />
        ) : (
          <CloseCircleOutlined
            style={{ color: "#ff4d4f" }}
            title="Không chấm công tự động"
            onClick={() => onSetAuto(record)}
          />
        ),
    },
  ];

  const fetchData = async (params = {}) => {
    setLoading(true);
    autoAttendApi({
      idTeam: JSON.stringify(params.idTeam),
    })
      .then((res) => {
        setData(res.data);
        // console.log(res.data);
        setLoading(false);
      })
      .catch((err) => {
        errorHandle(err);
        setLoading(false);
      });
  };

  const fetchListTeam = () => {
    ListBoPhanApi().then((res) => {
      const arrTeam = userInfo.team_permissions
        .filter((item) => item.phanquyen__ten_pq === "detailed_timesheet_ns")
        .map((item, index) => {
          const idBoPhanForTeam = res.data.filter((itemBP) =>
            itemBP.team.some((itemT) => itemT.id == item.team)
          );
          if (idBoPhanForTeam.length != 0) {
            return {
              idTeam: item.team,
              team: item.team__tenTeam,
              idBoPhan: idBoPhanForTeam[0].id,
            };
          }
          return false;
        })
        .filter((item) => item != false);
      const uniqueArrTeam = [
        ...new Map(arrTeam.map((item) => [item["idTeam"], item])).values(),
      ];
      uniqueArrTeam.sort(function (first, second) {
        return first["idTeam"] - second["idTeam"];
      });
      const arrIdTeam = uniqueArrTeam.map((item) => item.idTeam);
      const arrBoPhan = res.data.filter(({ team }) =>
        team.some((item) => arrIdTeam.includes(item.id))
      );
      if (arrBoPhan.length > 0) {
        setCurrentBoPhan([arrBoPhan[0].id]);
      }
      setLsBoPhan(arrBoPhan);

      setLsAllTeam(uniqueArrTeam);
      if (currentTeam.length === 0) {
        // setCurrentTeam(arrIdTeam.filter(x => arrBoPhan[0].team.map(item=>item.id).includes(x)));
        setCurrentTeam([
          arrIdTeam.filter((x) =>
            arrBoPhan[0].team.map((item) => item.id).includes(x)
          )[0],
        ]); // 200423 lấy element đầu tiên đặt trong list
      }
      setLsTeam(
        uniqueArrTeam.filter((x) =>
          arrBoPhan[0].team.map((item) => item.id).includes(x.idTeam)
        )
      );
    });
  };

  useEffect(() => {
    if (currentTeam.length === 0) {
      setData([]);
      return;
    }
    fetchData({ idTeam: currentTeam });
  }, [currentTeam]);

  useEffect(() => {
    if (
      userInfo &&
      userInfo.team_permissions &&
      userInfo.team_permissions.length > 0
    ) {
      fetchListTeam();
    }
  }, [userInfo]);

  const onChangeBoPhan = (value) => {
    if (value.length > 0) {
      setCurrentBoPhan(value);
      const lsTeamWith_BP = lsAllTeam.filter((x) => value.includes(x.idBoPhan));
      setLsTeam(lsTeamWith_BP);
      setCurrentTeam([lsTeamWith_BP.map((item) => item.idTeam)[0]]); // 200423
    } else {
      setLsTeam([]);
      setCurrentBoPhan([]);
      setCurrentTeam([]);
    }
  };

  const tPropsConfig_BoPhan = {
    treeData: [
      {
        title:
          currentBoPhan.length > 0 ? (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan([]);
                }
              }}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan(lsBoPhan.map((item) => item.id));
                }
              }}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeDataBoPhan,
    ],
    value: treeDataBoPhan.length > 0 ? currentBoPhan : undefined,
    onChange: onChangeBoPhan,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    placeholder: "Chọn bộ phận",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };

  useEffect(() => {
    const treeDataBoPhan = lsBoPhan.map((item) => {
      return { title: item.tenBophan, value: item.id, key: item.id };
    });
    setTreeDataBoPhan(treeDataBoPhan);
    if (currentBoPhan.length === 0) {
      setCurrentBoPhan(lsBoPhan.map((item) => item.id));
    }
  }, [lsBoPhan]);

  const onChangeTeam = (value) => {
    if (value.length > 0) {
      setCurrentTeam(value);
    } else {
      setCurrentTeam([]);
    }
  };

  const onBlurTeamSelect = () => {
    if (currentTeam.length === 0) {
      openNotificationWithIcon("error", "Lỗi", "Vui lòng chọn ít nhất 1 team");
    }
  };

  const tPropsConfig = {
    treeData: [
      {
        title:
          !loading && currentTeam.length > 0 ? (
            <span
              onClick={() => setCurrentTeam([])}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => setCurrentTeam(lsTeam.map((item) => item.idTeam))}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeData,
    ],
    value: treeData.length > 0 ? currentTeam : undefined,
    onChange: onChangeTeam,
    onBlur: onBlurTeamSelect,

    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    placeholder: "Chọn team",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };

  useEffect(() => {
    const treeDataTemp = lsTeam.map((item) => {
      return { title: item.team, value: item.idTeam, key: item.idTeam };
    });
    setTreeData(treeDataTemp);
  }, [lsTeam]);

  const onAddTeamAutoAttend = (values) => {
    // Thêm user theo team lên auto attend
    var get_data_team = data.filter(
      item => item.fore_team__id == values[0] && item.is_auto_attend == false
    );
    if (get_data_team.length == 0 || get_data_team.length != data.length) {
      openNotificationWithIcon("error", "Đã có nhân viên được tạo chấm công tự động sáng T7.");
      return;
    }
    var ls_id_user = get_data_team.map((e) => e.id);

    PostAutoAttendApi({
      ls_id_user: ls_id_user,
    })
      .then((r) => {
        fetchData({ idTeam: currentTeam });
        setLoading(false);
        setModalAddTeamAuto(false)
        openNotificationWithIcon("success", "Cài đặt thành công", "");
      })
      .catch((err) => {
        if (err.data.error) {
          openNotificationWithIcon("error", err.data.error);
          setLoading(false);
        }
      });
  };

  return (
    <>
      <Modal
        title={
          <div
            style={{
              // display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>Danh sách nhân viên</span>
            <Button
              type="link"
              icon={<QuestionCircleOutlined />}
              onClick={() => showDrawer()}
              style={{
                float: "right",
                marginRight: "25px",
                paddingBottom: "20px",
              }}
            ></Button>
          </div>
        }
        open={params.isShowAutoAttend}
        onCancel={params.onCancel}
        footer={false}
        width={1100}
        className={"site-drawer-render-in-current-wrapper"}
        bodyStyle={{ padding: "0px 12px 12px 12px", minHeight: "500px" }}
        maskClosable={false} // Tắt click ra ngoài để đóng
      >
        <div className="row">
          <div
            className={
              "col-12 mb-2 d-sm-flex align-items-center justify-content-between"
            }
          >
            <div className={"col"}>
              <div className="styleBadge">
                <Badge.Ribbon
                  text="Bộ phận"
                  color="gray"
                  style={{ color: "red" }}
                >
                  <TreeSelect {...tPropsConfig_BoPhan} />
                </Badge.Ribbon>
              </div>
              <div className="styleBadge">
                <Badge.Ribbon text="Team" color="gray" style={{ color: "red" }}>
                  <TreeSelect {...tPropsConfig} />
                </Badge.Ribbon>
              </div>
            </div>
            <div className={"col"}>
              <Row gutter={[8, 8]} style={{ flexDirection: "row-reverse" }}>
                <Col>
                  <Button
                    type="primary"
                    className={"m-2"}
                    onClick={() =>setModalAddTeamAuto(true)}
                  >
                    Chấm công ca sáng thứ 7
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <Table
          dataSource={data}
          columns={columns}
          loading={loading}
          bordered={true}
          sticky={true}
          // scroll={{x:700,y:500}}
          scroll={data.length > 0 && { x: 700, y: 400 }}
          className={"custom-table-hover style-6"}
          size={"small"}
          rowKey="id"
          pagination={false}
        />
         {isModalAddTeamAuto && (
        <ModalAddTeamAuto
          isModalAddTeamAuto={isModalAddTeamAuto}
          setModalAddTeamAuto={setModalAddTeamAuto}
          currentTeam={currentTeam}
          lsTeam={lsTeam}
          onAddTeamAutoAttend={onAddTeamAutoAttend}
        />
      )}
        <Drawer
          title="Hướng dẫn sử dụng"
          placement="right"
          onClose={closeDrawer}
          open={isDrawerOpen}
          width={450}
          keyboard
          getContainer={false}
        >
          <p>
            <strong>1. Cài chấm công ca sáng thứ 7</strong>
          </p>
          <p>
            Tại cột "Chấm công ca sáng T7", click vào icon{" "}
            <CloseCircleOutlined /> để đặt chấm công tự động.
          </p>

          <p>
            <strong>2. Xóa chấm công ca sáng thứ 7</strong>
          </p>
          <p>
            Tại cột "Chấm công ca sáng T7", click vào icon{" "}
            <CheckCircleOutlined /> để xóa chấm công tự động .
          </p>

          <p>
            <strong>3. Chấm công theo team</strong>
          </p>
          <p>
            Chọn Team sau đó chọn nút "Chấm công ca sáng thứ 7" để cài chấm công tự động cho cả team.
          </p>

          <p style={{ color: "red" }}>
            <strong>Lưu ý:</strong>
          </p>
          <p>
            - Chấm công theo team chỉ sử dụng khi toàn bộ nhân viên của team chưa
            được cài chấm công tự động sáng thứ 7, hoặc không thuộc loại user tự động chấm công.
          </p>
          <p>
            - Hệ thống tự động chạy chấm công cho các user vào 23h15 mỗi Thứ 7.
          </p>
        </Drawer>
      </Modal>
    </>
  );
};

export default ModalAutoAttend;
